import { checkRolePermission } from "./common/api/commons";
import { queryClient } from "./common/api/tanstack";
import { getServices } from "./common/core/baseinfo";
import { send } from "./common/core/request";
import { ENABLE_CHECK_ROLE_PERMISSION } from "./feature_flags";
import { kceQuotasOptions, vpcQuotasOptions } from "./features/Cluster/hooks/use-kce-quotas";

export function preload() {
  queryClient.prefetchQuery({
    queryKey: ["DescribeRegions"],
    queryFn: () => send(getServices().getRegions()),
  });
  if (ENABLE_CHECK_ROLE_PERMISSION) {
    queryClient.prefetchQuery({
      queryKey: ["RolePermissionChecker"],
      queryFn: async () => {
        await send(checkRolePermission());
        return true;
      },
    });
  }
  const currentRegion = import.meta.env.VITE_REGION;
  if (currentRegion) {
    queryClient.prefetchQuery(kceQuotasOptions(currentRegion));
    queryClient.prefetchQuery(vpcQuotasOptions(currentRegion));
  }
}
